export default "__VITE_ASSET__CdK3NVXO__"